import React, { useEffect, useState } from "react";
import api from "../../../api";
import { useTranslation } from "../../../hooks/useTranslation";
import { useInView } from "../../../hooks/useInView";
import placeholderLogo from "../../../images/mcdonalds-logo.png";
import { Skeleton } from "../../Ui/Skeleton/Skeleton";
import ProgressiveImage from "../../Ui/ProgressiveImage/ProgressiveImage";

const OfferCardSkeleton = () => (
  <div className="card elev-md" style={{ padding: 0, overflow: "hidden" }}>
    <Skeleton height={220} radius={0} />
    <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 8 }}>
      <Skeleton width="40%" height={12} />
      <Skeleton width="70%" height={19} />
      <Skeleton width="90%" height={14} />
      <Skeleton width="60%" height={14} />
    </div>
  </div>
);

const OffersSection = ({ onGoSignin }) => {
  const { t } = useTranslation();
  const [ref, isInView] = useInView(0, "250px 0px");
  const [offers, setOffers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isInView) return;
    api
      .getVoucherPreviews(3)
      .then((vouchers) => setOffers(Array.isArray(vouchers) ? vouchers : []))
      .catch((err) => console.error("Error fetching offers for landing page:", err))
      .finally(() => setIsLoading(false));
  }, [isInView]);

  if (!isLoading && offers.length === 0) return null;

  return (
    <section id="offers" className="sp-section" style={{ paddingLeft: 32, paddingRight: 32, background: "var(--color-accent-100)" }}>
      <div style={{ maxWidth: 1240, margin: "0 auto" }}>
        <div className="tag tag-neutral">{t.landingNavOffers}</div>
        <h2 style={{ marginTop: 10 }}>{t.landingOffersHeading}</h2>
        <p style={{ opacity: 0.75 }}>{t.landingOffersSubtitle}</p>
        <div
          ref={ref}
          className="sp-cards-grid"
          style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 24, marginTop: 30 }}
        >
          {isLoading && Array.from({ length: 3 }).map((_, i) => <OfferCardSkeleton key={i} />)}
          {!isLoading && offers.map((voucher) => (
            <div
              key={voucher._id}
              className="card elev-md sp-offer-card"
              style={{ padding: 0, overflow: "hidden", cursor: "pointer" }}
              onClick={onGoSignin}
            >
              <div style={{ position: "relative" }}>
                <div className="sp-card-media" style={{ borderRadius: 0, height: 220 }}>
                  <ProgressiveImage
                    src={voucher.backgroundImageUrl || voucher.company?.logoUrl || placeholderLogo}
                    alt=""
                    fallbackSrc={placeholderLogo}
                    loading="lazy"
                    fill
                    imgClassName="washed"
                  />
                </div>
                <span className="tag tag-accent" style={{ position: "absolute", top: 14, left: 14 }}>
                  {t.landingOffersBadge}
                </span>
              </div>
              <div style={{ padding: 20, display: "flex", flexDirection: "column", gap: 8 }}>
                <div style={{ fontSize: 12, opacity: 0.6, letterSpacing: "0.03em" }}>{voucher.company?.name}</div>
                <div className="card-title" style={{ fontSize: 19 }}>{voucher.title}</div>
                <p className="card-body" style={{ fontSize: 14, lineHeight: 1.55 }}>{voucher.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OffersSection;
